import { VECTORS } from '../components/simConstants'

const VECTOR_BY_API = {
  link: 'link',
  url: 'link',
  dataEntry: 'dataEntry',
  data_entry: 'dataEntry',
  attachment: 'attachmentHtml',
}

const attachmentVectorKey = (format) => {
  if (!format) {
    return 'attachmentHtml'
  }

  const normalized = String(format).toUpperCase()
  const byFormat = {
    HTML: 'attachmentHtml',
    PDF: 'attachmentPdf',
    DOCX: 'attachmentDocx',
    XLS: 'attachmentXls',
    XLSX: 'attachmentXls',
  }

  return byFormat[normalized] || 'attachmentHtml'
}

const resolveVector = (payload) => {
  if (payload.fileFormat || payload.file_format || payload.vector === 'attachment') {
    return VECTORS[attachmentVectorKey(payload.fileFormat || payload.file_format)]
  }

  const key = VECTOR_BY_API[payload.vector] || 'dataEntry'
  return VECTORS[key]
}

const resolvePhase = (payload) => {
  if (
    payload.phase === 'sending' ||
    payload.phase === 'collecting' ||
    payload.phase === 'completed'
  ) {
    return payload.phase
  }

  return 'collecting'
}

export const EMPTY_SIMULATION_FUNNEL = {
  available: false,
  vector: VECTORS.dataEntry,
  delivered: 0,
  scheduled: 0,
  opened: 0,
  counts: { submitted: 0, clicked: 0, reported: 0, opened: 0, none: 0 },
  metrics: { lured: 0 },
  phase: null,
}

export const adaptSimulationFunnel = (payload) => {
  if (payload == null || payload.available === false) {
    return EMPTY_SIMULATION_FUNNEL
  }

  const vector = resolveVector(payload)
  const delivered = payload.delivered ?? 0
  const opened = payload.opened ?? 0
  const submitted = payload.dataSubmitted ?? payload.data_submitted ?? 0
  const clickedStage = payload.clicked ?? payload.lured ?? 0
  const lured = Math.max(clickedStage, submitted)

  return {
    available: true,
    vector,
    delivered,
    scheduled: payload.scheduled ?? 0,
    opened,
    counts: {
      submitted,
      clicked: Math.max(0, lured - submitted),
      reported: 0,
      opened: 0,
      none: 0,
    },
    metrics: { lured },
    phase: resolvePhase(payload),
  }
}
